export default __webpack_public_path__ + "static/media/07-main.c8e4755f.jpg";